let id = 1;
const randomId = () => {
	id++;
	return id;
};

export const navbarItems = [
	{
		id: randomId(),
		link: "/",
		icon: "fas fa-home",
		title: "لوحة التحكم",
		children: [],
	},
	{
		id: randomId(),
		link: "/moderators/index",
		icon: "fas fa-users-cog",
		title: "المشرفين",
		children: [
			{
				id: randomId(),
				title: "جميع المشرفين",
				link: "/moderators/index",
			},
			{
				id: randomId(),
				title: "اضافة مشرف جديد",
				link: "/moderators/create",
			},
		],
	},

	// {
	// 	id: randomId(),
	// 	link: "/projects/index",
	// 	icon: "fas fa-solid fa-building",
	// 	title: "المشاريع",
	// 	children: [
	// 		{
	// 			id: randomId(),
	// 			title: "جميع المشاريع",
	// 			link: "/projects/index",
	// 		},
	// 		{
	// 			id: randomId(),
	// 			title: "اضافة مشروع جديدة",
	// 			link: "/projects/create",
	// 		},
	// 		{
	// 			id: randomId(),
	// 			title: "جميع الفئة",
	// 			link: "/category/index",
	// 		},
	// 		{
	// 			id: randomId(),
	// 			title: "اضافة الفئة جديدة",
	// 			link: "/category/create",
	// 		},
	// 	],
	// },
	{
		id: randomId(),
		link: "/moderators/index",
		icon: "fas fa-desktop",
		title: "تحكم الخلفيات",
		children: [
			{
				id: randomId(),
				title: "خلفية العناوين",
				link: "/backgrounds/breadcrumbs",
			},
			{
				id: randomId(),
				title: "خلفية الخدمات",
				link: "/backgrounds/services",
			},
			{
				id: randomId(),
				title: "خلفية اراء العملاء",
				link: "/backgrounds/testmonials",
			},
			{
				id: randomId(),
				title: "خلفية اتصل بنا",
				link: "/backgrounds/contactUs",
			},
		],
	},
	{
		id: randomId(),
		link: "/services/index",
		icon: "fas fa-solid fa-laptop-house",
		title: "الخدمات",
		children: [
			{
				id: randomId(),
				title: "جميع الخدمات",
				link: "/services/index",
			},
			{
				id: randomId(),
				title: "اضافة خدمة جديدة",
				link: "/services/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/partners",
		title: "عملاؤنا الرئيسين",
		icon: "fas fa-solid fa-people-carry",
		children: [
			{
				id: randomId(),
				title: "جميع عملاؤنا الرئيسين",
				link: "/partners/index",
			},
			{
				id: randomId(),
				title: "اضافة عميل جديد",
				link: "/partners/create",
			},
		],
	},

	{
		id: randomId(),
		link: "/stratigic-clients",
		title: "شركاؤنا الاستراتيجين",
		icon: "fas fa-solid fa-people-carry",
		children: [
			{
				id: randomId(),
				title: "جميع شركاؤنا الاستراتيجين",
				link: "/stratigic-clients/index",
			},
			{
				id: randomId(),
				title: "اضافة شريك جديد",
				link: "/stratigic-clients/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/comments/index",
		icon: "fas fa-comments",
		title: "اراء العملاء",
		children: [
			{
				id: randomId(),
				title: "جميع الاراء",
				link: "/comments/index",
			},
			{
				id: randomId(),
				title: "اضافة رائ جديدة",
				link: "/comments/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/blogs/index",
		icon: "fas fa-blog",
		title: "المدونة",
		children: [
			{
				id: randomId(),
				title: "جميع المدونات",
				link: "/blogs/index",
			},
			{
				id: randomId(),
				title: "اضافة مدونة جديدة",
				link: "/blogs/create",
			},
			{
				id: randomId(),
				title: "جميع فئات المدونات",
				link: "/blogs/categories/index",
			},
			{
				id: randomId(),
				title: "اضافة فئة مدونة جديدة",
				link: "/blogs/categories/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/orders/index",
		icon: "fas fa-envelope",
		title: "الطلبات",
		children: [],
	},
	{
		id: randomId(),
		link: "/social",
		title: "وسائل التواصل",
		icon: "fas fa-id-card",
		children: [
			// {
			// 	id: randomId(),
			// 	title: " انواع التواصل",
			// 	link: "/social/socialType/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "اضافة نوع تواصل",
			// 	link: "/social/socialType/create",
			// },
			{
				id: randomId(),
				title: " روابط التواصل",
				link: "/social/links/index",
			},
			{
				id: randomId(),
				title: "اضافة رابط تواصل",
				link: "/social/links/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/siteinfo",
		icon: "far fa-address-card",
		title: " بيانات الموقع ",
		children: [
			{
				id: randomId(),
				title: "لافتات الترحيب",
				link: "/siteinfo/heroSection/index",
			},
			{
				id: randomId(),
				title: "عن نماء",
				link: "/siteinfo/aboutUs/show/about-us",
			},
			{
				id: randomId(),
				title: "قيمنا",
				link: "/siteinfo/values",
			},
			// {
			// 	id: randomId() ,
			// 	title: "البيانات الاضافيه",
			// 	link: "/aboutPage/sideinfo/index" ,
			// },
			// {
			// 	id: randomId(),
			// 	title: "المميزات",
			// 	link: "/aboutPage/advantages/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "الاحصائيات",
			// 	link: "/aboutPage/statistics/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "الأسئله الشائعه",
			// 	link: "/aboutPage/questions/index",
			// },
		],
	},
	// {
	// 	id: randomId(),
	// 	link: "/breadcrump/index",
	// 	icon: "fas fa-envelope",
	// 	title: "خلفيه الصفحات",
	// 	children: [],
	// },
];

export const getId = obj => obj?._id || obj?.id;

export const handleImage = image => {
	if (image) {
		if (image?.includes("https://") || image?.includes("http://")) return image;
		if (!image.startsWith("/")) image = `/${image}`;
		return `${`${process.env.REACT_APP_API_URL}`?.replace("/api", "")}${image}`;
	}

	return image;
};
